<app-sidebar [isOpen]="open" (close)="sidebarCancel()" [bigSize]="false">
  @if (open) {
    <div class="list-management-sidebar astral-sidebar-shell">
      <header class="list-management-sidebar__header astral-sidebar-header astral-stack-s">
        <h2 class="astral-sidebar-heading">{{ title | translate }}</h2>
        <astral-input
          class="list-management-sidebar__search"
          [control]="form.controls['searchFilter']"
          [placeholderText]="searchCaption"
          [withShell]="false"
        ></astral-input>
      </header>

      <div class="list-management-sidebar__content astral-sidebar-content astral-stack-m">
        <section class="list-management-sidebar__section astral-stack-s">
          @if (form.controls['searchFilter'].value) {
            <ul class="list-management-sidebar__list">
              @for (item of sidebarItems | keywordFilter : form.controls['searchFilter'].value : 'caption'; track item) {
                <li class="list-management-sidebar__item">
                  <astral-checkbox
                    [checked]="item.selected"
                    [label]="item.caption"
                    [variant]="'compact'"
                    (checkedChange)="setItemSelected(item, $event)"
                  ></astral-checkbox>
                </li>
              }
            </ul>
          }

          @if (!form.controls['searchFilter'].value) {
            <div class="list-management-sidebar__selection-controls">
              <astral-checkbox
                [checked]="checkAllSelected()"
                [label]="'SELECT_ALL'"
                [variant]="'compact'"
                (checkedChange)="toggleAll($event)"
              ></astral-checkbox>
              <astral-button variant="secondary" size="small" type="button" labelKey="COMMON.RESET" (click)="restoreDefaults()"></astral-button>
            </div>
            @if (selectedItems.length > 0) {
              <div class="list-management-sidebar__section-header">
                <h5>{{ 'SELECTED' | translate }}</h5>
                @if (reorderable) {
                  <astral-popover [helpText]="'REORDER_HELPTEXT'"></astral-popover>
                }
              </div>
              <ul
                class="list-management-sidebar__list list-management-sidebar__list--reorderable"
                cdkDropList
                [cdkDropListDisabled]="!reorderable"
                [cdkDropListData]="selectedItems"
                (cdkDropListDropped)="drop($event)"
                >
                @for (item of selectedItems; track item) {
                  <li
                    cdkDrag
                    cdkDragLockAxis="y"
                    cdkDragBoundary=".list-management-sidebar__list--reorderable"
                    class="list-management-sidebar__item"
                    >
                    <astral-checkbox
                      [checked]="item.selected"
                      [label]="item.caption"
                      [variant]="'compact'"
                      (checkedChange)="setItemSelected(item, $event)"
                    ></astral-checkbox>
                    @if (reorderable) {
                      <div class="list-management-sidebar__move" cdkDragHandle></div>
                    }
                  </li>
                }
              </ul>
            }
            @if (deselectedItems.length > 0) {
              <div class="list-management-sidebar__section-header">
                <h5>{{ 'AVAILABLE' | translate }}</h5>
              </div>
              <ul class="list-management-sidebar__list">
                @for (item of deselectedItems; track item) {
                  <li class="list-management-sidebar__item">
                    <astral-checkbox
                      [checked]="item.selected"
                      [label]="item.caption"
                      [variant]="'compact'"
                      (checkedChange)="setItemSelected(item, $event)"
                    ></astral-checkbox>
                  </li>
                }
              </ul>
            }
          }
        </section>
      </div>
      <footer class="list-management-sidebar__footer astral-sidebar-footer">
        <astral-button
          variant="primary"
          [disabled]="validate ? !isAnyCheckboxSelected() : null"
          type="button"
          (click)="sidebarSave()"
          labelKey="KEYTYPE.UPDATE_OBJECT_KEYS"
          [appTooltip]="'VALIDATE_COLUMNS_CHANGE' | translate"
          [tooltipDisabled]="!validate || isAnyCheckboxSelected()"
        ></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="sidebarCancel()"></astral-button>
      </footer>
    </div>
  }
</app-sidebar>
